// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1J1QA","rootNoMargin":"styles_rootNoMargin__1gFHa"};